(() => {
  const offer = document.querySelector('[data-ys-launch-offer]');
  if (!offer || window.YogaSpaceLaunchOffer) return;
  const endsAt = Date.parse(offer.dataset.endsAt);
  const startsAt = Date.parse(offer.dataset.startsAt);
  const currency = offer.dataset.currency;
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-GB',{style:'currency',currency,minimumFractionDigits:0,maximumFractionDigits:2}).format(value / 100);
  const status = offer.querySelector('[data-launch-status]');
  function updatePrices(variants) {
    variants.forEach(variant => {
      document.querySelectorAll(`[data-ys-plan-price][data-variant-id="${variant.id}"]`).forEach(price => {
        price.dataset.basePrice = String(variant.price);
        price.dataset.comparePrice = String(variant.compareAt || 0);
        price.textContent = money(variant.price);
        document.querySelectorAll(`[data-ys-annual-variant="${variant.id}"]`).forEach(annual => {
          annual.textContent = `${money(variant.compareAt > variant.price ? variant.compareAt : variant.price)} ${annual.dataset.period || 'per year'}`;
        });
      });
    });
  }
  window.addEventListener('yogaspace:native-prices-unverified',()=>{ document.querySelectorAll('[data-ys-plan-price],[data-ys-comparison-price]').forEach(price=>price.textContent='Updating price…'); });
  window.addEventListener('yogaspace:native-prices-updated',event=>updatePrices(event.detail.variants));
  window.YogaSpaceLaunchOffer = {
    lineProperties() { return {}; },
    async prepare() {
      const before = [...document.querySelectorAll('[data-ys-plan-price][data-variant-id]')].map(price=>Number(price.dataset.basePrice));
      const variants = await window.YogaSpaceNativeCart?.prepare();
      if (!variants) throw new Error('Your plan price could not be checked. Please refresh and try again.');
      updatePrices(variants);
      if (variants.some((variant,index)=>variant.price !== before[index])) throw new Error('Plan prices have changed. Review your plan and add it again.');
    }
  };
  function tick() {
    offer.hidden = Date.now() < startsAt || Date.now() >= endsAt;
    if (offer.hidden) return;
    const remaining = Math.max(0,Math.ceil((endsAt-Date.now())/1000));
    const values = {days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};
    Object.entries(values).forEach(([unit,value])=>{
      const element = offer.querySelector(`[data-countdown-${unit}]`);
      if (element) element.textContent = String(value).padStart(2,'0');
    });
  }
  document.querySelectorAll('.yogaspace-product-main input[name="properties[_cork_space_voucher]"]').forEach(input=>input.remove());
  if (status) { status.textContent='';status.hidden=true; }
  tick();setInterval(tick,1000);
})();
